import React, { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { connect } from 'react-redux';
import { withFirebase } from 'react-redux-firebase';
import { useRouteMatch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Input from '../../forms/input';
import { checkParent } from '../../utility/check-parent';
import { getLocalCart } from '../../utility/get-local-cart';
import { useResources } from '../../utility/use-resources';
import { useSAYT } from "../../utility/use-sayt";
import { useScrollDirection } from '../../utility/use-scroll-direction';
import MiniCart from '../cart/mini-cart';
import { NavLink } from '../commons/link';
import NewsBanner from "../commons/news-banner";
import MiniUserArea from '../reserved-area/mini-user-area';
import { Menu } from './menu/Menu';
import { MobileMenu } from './menu/mobile/MobileMenu';
import { VisibleMenuItemsProvider } from './menu/useVisibleMenuItems';
import { Backdrop, StyledHeader } from './styled';

const LogoElement =  (props) => {
  const isHomepage = useRouteMatch({ path: '/', exact: true });
  if (isHomepage) return <h1 {...props} />

  return <p {...props} />
}

const HeaderCanary = props => {
  const [isOpen, setIsOpen] = useState(true)
  const [searchOpen, setSearchOpen] = useState(false);
  const [cartOpen, setCartState] = useState(false);
  const [userOpen, setUserState] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const scrollDirection = useScrollDirection()
  //const userCategory = useUserCategory(props.firebase, props.auth.uid);
  const [r] = useResources("menu");

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("hide-overflow")
    } else {
      document.body.classList.remove("hide-overflow")
    }
  }, [isOpen])

  const closeAll = () => {
    setIsOpen(false);
    setSearchOpen(false);
    setCartState(false);
    setUserState(false);
    setSearchKeyword("");
    document.body.focus();
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    props.history.push("/search/" + encodeURIComponent(searchKeyword));
    closeAll();
  };
  useSAYT(searchOpen, setSearchOpen, closeAll);

  const toggleCart = () => {
    let cartState = cartOpen;
    closeAll();
    setCartState(!cartState);
  };

  const toggleSearch = () => {
    let searchState = searchOpen;
    closeAll();
    setSearchOpen(!searchState);
  };

  const toggleUser = () => {
    let userState = userOpen;
    closeAll();
    setUserState(!userState);
  };

  useEffect(() => {
    closeAll()
  }, [props.location])

  const onOutsideClickSearch = (e) => {
		const button = document.querySelector('.search-button')
		if (checkParent(button, e.target)) {
			return
		}
		setSearchOpen(false)
	}

  return (
    <VisibleMenuItemsProvider>
      <StyledHeader
        data-scroll-direction={scrollDirection}
        data-open-state={isOpen ? "open" : "closed"}
        data-search-state={searchOpen ? "open" : "closed"}
        data-cart-state={cartOpen ? "open" : "closed"}
        data-user-state={userOpen ? "open" : "closed"}
      >
        <nav id="header-nav">
          <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} />
          <LogoElement className="logo-holder">
            <NavLink to="/">
              <img
                alt="Vicoustic"
                src={
                  "/resources/images/" +
                  (searchOpen ? "logo-white.svg" : "logo.svg")
                }
              />
            </NavLink>
          </LogoElement>
          <Menu location={props.location} />
          <ul className="nav-buttons">
            <li>
              <button className="search-button" onClick={toggleSearch}>
                <i className="fas fa-search" />
              </button>
              <Backdrop $open={searchOpen}>
                <OutsideClickHandler onOutsideClick={onOutsideClickSearch}>
                  <div className="search">
                    <form onSubmit={handleSearchSubmit} autoComplete="off">
                      <Input
                        id="search-ipt"
                        tabIndex={searchOpen ? "" : "-1"}
                        takeFocus={searchOpen}
                        autoComplete="off"
                        value={searchKeyword}
                        onChange={(v) => setSearchKeyword(v)}
                        keepPlaceholder={true}
                        placeholder={r("searchPlaceholder")}
                      />
                    </form>
                  </div>
                </OutsideClickHandler>
              </Backdrop>
            </li>
            {(
              <li>
                <button className="cart-button" onClick={toggleCart}>
                  <i
                    className="fas fa-shopping-cart"
                    data-notifications={props.cartItemCount}
                  ></i>
                </button>
                <Backdrop $open={cartOpen}>
                  <MiniCart uid={props.auth.uid} close={() => setCartState(false)} />
                </Backdrop>
              </li>
            )}
            <li>
              <button className="user-button" onClick={toggleUser}>
                <i className="fas fa-user"></i>
              </button>
              <Backdrop $open={userOpen}>
                <MiniUserArea profile={props.profile} open={userOpen} uid={props.auth.uid} close={() => setUserState(false)} />
              </Backdrop>
            </li>
          </ul>
        </nav>
        <NewsBanner scrollDirection={scrollDirection} />
      </StyledHeader>
    </VisibleMenuItemsProvider>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    cartItemCount: state.firebase.auth.uid
      ? Object.keys(state.firestore.data?.users?.[state.firebase.auth.uid]?.cart ?? {}).length
      : Object.keys(getLocalCart()).length,
  };
};

export default compose(
  withRouter,
  withFirebase,
  connect(mapStateToProps)
)(HeaderCanary);
